import React from "react";
import { Animated, Platform, Pressable, StyleSheet } from "react-native";
import { requireOptionalNativeModule } from "expo";

import { t } from "@/localization";

// iOS blurs with expo-blur when the build has it; an older binary running newer
// JS falls back to the dim layer alone. Android has no cheap live blur, so it dims.
const BlurView =
  Platform.OS === "ios" && requireOptionalNativeModule("ExpoBlur")
    ? require("expo-blur").BlurView
    : null;

// Behind the modal layout: the dimmed, blurred dashboard, or a plain colour
// when there is nothing under the modal (`blur` false). Pressing it closes.
// `appear` (0→1) fades the layers in. The web blur fades itself: on a
// see-through parent the browser wouldn't blur the page behind. iOS can't
// fade a blur view, so it shows at once under the fading dim.
const Backdrop = ({ onPress, blur = true, appear = 1 }) => (
  <Pressable
    accessibilityRole="button"
    accessibilityLabel={t("Close")}
    focusable={false}
    onPress={onPress}
    style={[StyleSheet.absoluteFill, !blur && styles.plain]}
  >
    {blur &&
      (Platform.OS === "web" ? (
        <Animated.View
          style={[StyleSheet.absoluteFill, styles.webBlur, { opacity: appear }]}
        />
      ) : BlurView ? (
        <BlurView intensity={28} tint="light" style={StyleSheet.absoluteFill} />
      ) : null)}
    {blur && (
      <Animated.View
        style={[StyleSheet.absoluteFill, styles.dim, { opacity: appear }]}
      />
    )}
  </Pressable>
);

const styles = StyleSheet.create({
  webBlur: { backdropFilter: "blur(10px)" },
  dim: { backgroundColor: "rgba(15, 23, 42, 0.3)" },
  plain: { backgroundColor: "#E2E8F0" },
});

export default Backdrop;
